import initScrollReveal from "./src/scripts/scrollReveal";
import initTiltEffect from "./src/scripts/tiltAnimation";
import { targetElements, defaultProps } from "./src/data/scrollRevealConfig";

// import dynamic project data and render them into the grid
import projects from "./src/data/projects.js";

/**
 * Render all projects defined in src/data/projects.js into the DOM.  This
 * function selects the container with id "projectsGrid" and appends
 * a project card for each entry in the projects array.  Each card
 * includes the media (image or video), title, description and
 * associated links.  The "load-hidden" class is applied so that
 * ScrollReveal can animate the cards into view.
 */
function renderProjects() {
  const grid = document.getElementById("projectsGrid");
  if (!grid) return;
  projects.forEach((p) => {
    const card = document.createElement("div");
    card.className = "project-card load-hidden";
    // Build media element based on the media type
    let mediaHTML;
    if (p.mediaType === "video") {
      mediaHTML = `<video class="project-media" controls><source src="${p.mediaSrc}" type="video/mp4"></video>`;
    } else {
      mediaHTML = `<img class="project-media" src="${p.mediaSrc}" alt="${p.title} image">`;
    }
    const liveLinkButton = p.liveLink
      ? `<a rel="noopener" target="_blank" class="cta-btn cta-btn--hero" href="${p.liveLink}">See Live</a>`
      : "";
    const sourceLinkButton = p.sourceLink
      ? `<a rel="noopener" target="_blank" class="cta-btn text-color-main" href="${p.sourceLink}">Source Code</a>`
      : "";
    card.innerHTML = `
      ${mediaHTML}
      <div class="project-content">
        <h3 class="project-title">${p.title}</h3>
        <p class="project-desc">${p.description}</p>
        <div class="project-links">
          ${liveLinkButton}
          ${sourceLinkButton}
        </div>
      </div>
    `;
    grid.appendChild(card);
  });
}

// Render projects once DOM content is ready, then initialise animations
document.addEventListener("DOMContentLoaded", () => {
  renderProjects();
  initTiltEffect();
  initScrollReveal(targetElements, defaultProps);
});

